import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_RESUME_SG_CHARGE_COL_DEF, transferRowData } from "presentation/constant/ResumeSGCharge/ResumeSGChargeColumnDefinition";
import { useResumeSGChargeVM } from "presentation/hook/ResumeSGCharge/useResumeSGChargeVM";
import { useResumeSGChargeTracked } from "presentation/store/ResumeSGCharge/ResumeSGChargeProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";


const ResumeSGChargeTablePanel: React.FC = () => {
    const [resumeSGChargeState] = useResumeSGChargeTracked();
    const resumeSGChargeVM = useResumeSGChargeVM();
    const gridRef: any = useRef(null);
    const { resumeSGChargeList } = resumeSGChargeState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(resumeSGChargeState.isSearchLoading || (!resumeSGChargeState.isSearchLoading &&
            resumeSGChargeList && resumeSGChargeList.length) ? false : true);
    }, [resumeSGChargeState.isSearchLoading, resumeSGChargeList]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        resumeSGChargeVM.updateSelectedRows(selectedRows);
    }, [resumeSGChargeVM])


    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='resume-sg-charge-table'
                isNewColumnSetting={true}
                columns={INITIAL_RESUME_SG_CHARGE_COL_DEF.slice()}
                data={transferRowData(resumeSGChargeList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [handleSelectionChange, resumeSGChargeList, showOverlay])

    return <>
        <TableWrapper>
            {memoTable}
        </TableWrapper>
    </>;
}

export default memo(ResumeSGChargeTablePanel);
